<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ds/lib/utils'

import type { CardVariants } from '.'

import { cardVariants } from '.'

const props = defineProps<{
  variant?: CardVariants['variant'];
  shape?: CardVariants['shape'];
  class?: HTMLAttributes['class'];
}>()
</script>

<template>
  <div
    data-slot="card"
    :data-variant="variant"
    :class="cn(cardVariants({ variant, shape }), props.class)"
  >
    <slot />
  </div>
</template>
